import global from "./global";
import sidebars from "./sidebars";
import alerts from "./alerts";
import subjects from "./subjects";
import user from "./user";
// import grid from "./grid";
import kbase from "./kbase";
import subject from "./subject";
import notifications from "./notifications";
import supportModal from "./supportModal";
import dataContacts from "./sidebarData/contacts"

//workflow
import state_files from "./workflow/state_files";
import state_comment from "./workflow/state_comment";
import login from "./login";
import mySubjects from "./mySubjects";
import form from "./form";

export default {
  global,
  sidebars,
  user,
  alerts,
  subjects,
  state_files,
  state_comment,
  // grid,
  kbase,
  subject,
  notifications,
  supportModal,
  dataContacts,
  login,
  mySubjects,
  form,
};
